module.exports = __webpack_public_path__ + "static/media/iconMenuMaintenanceMonitoringsActive.8be2cee2.svg";